import React from "react";
import anime from "animejs";
import Needle from "./Needle";
import VasDeference from "./VasDeference";
import VasDeferenceEchoVR from "./VasDeferenceEchoVR";

var timelineParameters = null;
var _this = null;

const animationStage1 = 0;
const animationStage2 = 4300;
const animationStage3 = 15500;
const animationStage4 = 24500;

export default class ProductAnimation extends React.Component {
  svgWidth = "561px";
  svgHeight = "330px";
  // stage = 1;

  onResize = () => {
    const width = typeof window !== undefined ? window.innerWidth : 1200;
    const svgWidth =
      width > 1050
        ? "561px"
        : width > 832
          ? "449px"
          : width > 650 ? "617px" : width > 449 ? "449px" : "393px";
    const svgHeight =
      width > 1050
        ? "330px"
        : width > 832
          ? "264px"
          : width > 650 ? "363px" : width > 449 ? "264px" : "231px";
    this.setState({ svgWidth: svgWidth, svgHeight: svgHeight });
  };

  componentDidMount() {
    _this = this;
    _this.previousStage = 0;
    const width = typeof window !== undefined ? window.innerWidth : 1200;
    this.svgWidth =
      width > 1050
        ? "561px"
        : width > 832
          ? "449px"
          : width > 650 ? "617px" : width > 449 ? "449px" : "393px";
    this.svgHeight =
      width > 1050
        ? "330px"
        : width > 832
          ? "264px"
          : width > 650 ? "363px" : width > 449 ? "264px" : "231px";

    const spermPath = anime.path("#ProductAnimation #spermPath");
    const spermPath2 = anime.path("#ProductAnimation #spermPath2");
    const echoVRPathVas = anime.path("#ProductAnimation #echoVRFluid");

    timelineParameters = anime.timeline({
      update: function(anim) {
        const currentTime = anim.duration * anim.progress / 100;
        switch (_this.stage) {
          case 1:
            if (currentTime > animationStage2) {
              anim.pause();
              anim.seek(animationStage1);
              anim.play();
            }
            break;
          case 2:
            if (currentTime > animationStage3) {
              anim.pause();
              anim.seek(animationStage2);
              anim.play();
            }
            break;
          case 3:
            if (currentTime < animationStage3 || currentTime == anim.duration) {
              anim.pause();
              anim.seek(animationStage3);
              anim.play();
            }
            break;
          case 4:
            if (currentTime < animationStage3 || currentTime == anim.duration) {
              anim.pause();
              anim.seek(animationStage3);
              anim.play();
            }
            break;
          default:
            if (currentTime > animationStage2) anim.pause();
            break;
        }
      }
    });

    const lowerNeedle = {
      targets: "#ProductAnimation #Needle",
      translateY: [-200, 0],
      translateX: [360, 360],
      easing: "easeOutQuad",
      duration: 3000,
      loop: false
    };

    const raiseNeedle = {
      targets: "#ProductAnimation #Needle",
      translateY: [0, -200],
      translateX: [360, 360],
      easing: "easeOutQuad",
      duration: 3000,
      delay: 1000,
      loop: false
    };

    const lowerPlunger = {
      targets: "#ProductAnimation #plunger",
      translateY: [0, 65],
      translateX: [1.347355, 1.347355],
      easing: "linear",
      duration: 4500,
      loop: false
    };

    const lowerPlungerContents = {
      targets: "#ProductAnimation #EchoVRPath",
      points: [
        {
          value:
            "1.3473547 140.237636 33.9297055 140.153416 33.9297055 140 1.3473547 140"
        }
      ],
      easing: "linear",
      offset: "-=4500",
      duration: 4500,
      loop: true
    };

    const scaleFluid = {
      targets: "#ProductAnimation #echoVRFluid",
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: "easeInOutQuad",
      duration: 4500,
      offset: "-=4500",
      loop: true
    };

    const showFluid = {
      targets: "#ProductAnimation #echoVRFluid",
      opacity: [0, 0.8],
      easing: "easeOutQuad",
      offset: "-=4500",
      duration: 4500,
      loop: true
    };

    const scaleFluidRightFace = {
      targets: "#ProductAnimation #echoVRRightFace",
      opacity: [0, 1],
      easing: "easeInOutQuad",
      duration: 1000,
      offset: "-=4500",
      loop: false
    };

    const scaleFluidLeftFace = {
      targets: "#ProductAnimation #echoVRLeftFace",
      translateX: echoVRPathVas("x"),
      translateY: echoVRPathVas("y"),
      easing: "easeInOutQuad",
      duration: 4500,
      offset: "-=4500",
      loop: false
    };

    const showFluidLeftFace = {
      targets: "#ProductAnimation #echoVRLeftFace",
      opacity: [0, 1],
      easing: "easeInOutQuad",
      duration: 1500,
      offset: "-=4500",
      loop: false
    };

    const zoomInOnVas = {
      targets: "#ProductAnimation",
      scale: 2,
      translateX: [0, -150],
      translateY: [0, -150],
      easing: "linear",
      duration: 2500,
      loop: false
    };

    const spermSwim = {
      targets: "#ProductAnimation #sperm .nature",
      translateX: spermPath("x"),
      translateY: spermPath("y"),
      rotate: spermPath("angle"),
      easing: "linear",
      scale: [0.35, 0.35],
      duration: 3500,
      loop: false,
      delay: function(nature, i, l) {
        return i * 150;
      }
    };

    const spermSwim2 = {
      targets: "#ProductAnimation #sperm .nature",
      translateX: spermPath2("x"),
      translateY: spermPath2("y"),
      rotate: spermPath2("angle"),
      easing: "easeOutCirc",
      scale: [0.4, 0.3],
      duration: 4000,
      loop: false,
      delay: function(nature, i, l) {
        return i * 200;
      }
    };

    const spermFade = {
      targets: "#ProductAnimation #sperm .nature",
      easing: "easeInQuad",
      translateY: function(nature, i, l) {
        i++;
        return "-=" + i + 1.5;
      },
      translateX: function(nature, i, l) {
        i++;
        if (i % 2 == 0) return "-=20";
        return "+=20";
      },
      rotate: "+=0",
      scale: [0.3, 0.1],
      opacity: [1, 0],
      duration: 6000,
      offset: "-=1000",
      delay: function(nature, i, l) {
        return i * 100;
      },
      loop: true
    };

    timelineParameters
      .add(spermSwim)
      .add(lowerNeedle)
      .add(lowerPlunger)
      .add(lowerPlungerContents)
      .add(scaleFluid)
      .add(showFluid)
      .add(showFluidLeftFace)
      .add(scaleFluidLeftFace)
      .add(scaleFluidRightFace)
      .add(raiseNeedle)
      .add(zoomInOnVas)
      .add(spermSwim2)
      .add(spermFade);

    window.addEventListener("resize", this.onResize);
  }

  componentWillReceiveProps(nextProps) {
    _this.previousStage = _this.stage;
    _this.stage = nextProps.stage > 0 ? nextProps.stage : 1;
    switch (nextProps.stage) {
      case 1:
        console.log("_this.previousStage");
        console.log(_this.previousStage);
        if (_this.previousStage != undefined || _this.previousStage != 0) {
          timelineParameters.pause();
          timelineParameters.seek(animationStage1);
          timelineParameters.play();
        }
        break;
      case 2:
        timelineParameters.pause();
        timelineParameters.seek(animationStage2);
        timelineParameters.play();
        break;
      case 3:
        timelineParameters.pause();
        timelineParameters.seek(animationStage3);
        timelineParameters.play();
        break;
      case 4:
        timelineParameters.pause();
        timelineParameters.seek(animationStage3);
        timelineParameters.play();
        break;
      default:
        timelineParameters.seek(animationStage1);
    }
  }

  render() {
    const WhiteBackground = (
      <g id="whiteBG">
        <rect
          id="bg-path-1"
          x="0"
          y="0.045045045"
          width="561"
          height="329.924067"
        />
        <use
          fill="#FFFFFF"
          fillOpacity="0"
          fillRule="evenodd"
          xlinkHref="#bg-path-1"
        />
        <rect
          stroke="#979797"
          strokeWidth="0.5"
          x="0.25"
          y="0.295045045"
          width="560.5"
          height="329.424067"
        />
      </g>
    );

    return (
      <div>
        <svg
          width={this.svgWidth}
          height={this.svgHeight}
          viewBox="0 0 561 330"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          display="block"
          preserveAspectRatio="none"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <svg width="660px" height="430px" viewBox="40 40 561 330">
              <g id="ProductAnimation">
                <VasDeference />
                <Needle />
                <VasDeferenceEchoVR />
              </g>
            </svg>
            {WhiteBackground}
          </g>
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductAnimation.js